(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebarza-3d-categories"]) return;
  try {
    
  (function () {
    var root = document.querySelector('#categories.ebarza3d-cats')
            || document.querySelector('#collections.ebarza3d-cats');
    if (!root) return;

    var tabsBar = root.querySelector('[data-cats-tabs]');
    var tabs = root.querySelectorAll('[data-cats-tab]');
    var subtabBars = root.querySelectorAll('[data-cats-subtabs-for]');
    var subtabs = root.querySelectorAll('[data-cats-subtab]');
    var panels = root.querySelectorAll('[data-cats-panel]');

    function centerInScroller(el, container) {
      if (!el || !container) return;
      var cRect = container.getBoundingClientRect();
      var eRect = el.getBoundingClientRect();
      var current = container.scrollLeft;
      var target = current + (eRect.left - cRect.left) - (cRect.width / 2) + (eRect.width / 2);
      container.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }

    function showPanel(panelKey) {
      panels.forEach(function (p) {
        var matches = p.getAttribute('data-cats-panel') === panelKey;
        p.classList.toggle('is-active', matches);
        if (matches) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
    }

    function activateTop(topKey, btn) {
      tabs.forEach(function (t) {
        var isActive = t.getAttribute('data-cats-tab') === topKey;
        t.classList.toggle('is-active', isActive);
        // WCAG 4.1.2: keep aria-selected in sync with visual state.
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      var hasSubs = false;
      var firstSubKey = null;
      subtabBars.forEach(function (bar) {
        var matches = bar.getAttribute('data-cats-subtabs-for') === topKey;
        bar.classList.toggle('is-visible', matches);
        if (matches) {
          hasSubs = true;
          var firstSub = bar.querySelector('[data-cats-subtab]');
          if (firstSub) firstSubKey = firstSub.getAttribute('data-cats-subtab');
          bar.querySelectorAll('[data-cats-subtab]').forEach(function (st, i) {
            st.classList.toggle('is-active', i === 0);
          });
        }
      });

      if (hasSubs && firstSubKey) {
        showPanel(topKey + ':' + firstSubKey);
      } else {
        showPanel(topKey);
      }

      if (btn && tabsBar) centerInScroller(btn, tabsBar);
    }

    function activateSub(parentKey, subKey, btn) {
      subtabBars.forEach(function (bar) {
        if (bar.getAttribute('data-cats-subtabs-for') !== parentKey) return;
        bar.querySelectorAll('[data-cats-subtab]').forEach(function (st) {
          st.classList.toggle('is-active', st.getAttribute('data-cats-subtab') === subKey);
        });
        if (btn) centerInScroller(btn, bar);
      });
      showPanel(parentKey + ':' + subKey);
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        activateTop(t.getAttribute('data-cats-tab'), t);
      });
    });

    subtabs.forEach(function (st) {
      st.addEventListener('click', function () {
        activateSub(
          st.getAttribute('data-cats-subtab-parent'),
          st.getAttribute('data-cats-subtab'),
          st
        );
      });
    });

    var initialTab = root.querySelector('[data-cats-tab].is-active');
    if (initialTab && tabsBar) {
      requestAnimationFrame(function () {
        centerInScroller(initialTab, tabsBar);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebarza-3d-divider"]) return;
  try {
    
  (function () {
    /* Assign data-flow-slot to each divider in DOM order so the per-slot
       hide rules emitted in the section template can match by index. */
    var dividers = document.querySelectorAll('[data-flow-divider]');
    dividers.forEach(function (el, i) {
      el.setAttribute('data-flow-slot', String(i + 1));
    });

    /* Scroll-triggered fade-in for all data-flow-fade elements */
    var els = document.querySelectorAll('[data-flow-fade]');
    if (!els.length) return;

    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (rm && rm.matches) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { obs.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebarza-3d-footer"]) return;
  try {
    
  (function () {
    /* Mobile accordion toggle for footer columns.
       Desktop (≥768px) ignores clicks via CSS `pointer-events: none`
       on the heading, so we don't need a viewport check in JS — the
       browser handles it. */
    document.querySelectorAll('[data-footer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebarza-3d-header"]) return;
  try {
    
  (function () {
    var header = document.querySelector('.ebarza3d-header[data-header]');
    if (!header) return;

    var THRESHOLD = 24;
    function syncScrollState() {
      var y = window.scrollY || window.pageYOffset || 0;
      header.classList.toggle('is-scrolled', y > THRESHOLD);
    }
    syncScrollState();
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        syncScrollState();
        ticking = false;
      });
    }, { passive: true });

    function smoothJump(targetId) {
      var el = document.getElementById(targetId);
      if (!el) return false;
      var headerH = header.getBoundingClientRect().height || 0;
      var rect = el.getBoundingClientRect();
      var top = rect.top + (window.scrollY || window.pageYOffset || 0) - headerH - 8;
      window.scrollTo({ top: top, behavior: 'smooth' });
      return true;
    }

    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href) return;
      var hashIndex = href.indexOf('#');
      if (hashIndex < 0) return;
      if (hashIndex === 0) {
        var id = href.slice(1);
        if (id && smoothJump(id)) {
          e.preventDefault();
          if (history.replaceState) history.replaceState(null, '', '#' + id);
        }
        return;
      }
      var path = href.slice(0, hashIndex);
      var here = window.location.pathname.replace(/\/$/, '');
      var there = path.replace(/^https?:\/\/[^\/]+/, '').replace(/\/$/, '');
      if (path && (here === there || there === '' )) {
        var id2 = href.slice(hashIndex + 1);
        if (id2 && smoothJump(id2)) {
          e.preventDefault();
          if (history.replaceState) history.replaceState(null, '', '#' + id2);
        }
      }
    });

    window.addEventListener('load', function () {
      if (window.location.hash && window.location.hash.length > 1) {
        var id = window.location.hash.slice(1);
        setTimeout(function () { smoothJump(id); }, 60);
      }
    });
  })();

  /* Header search trigger — open/close the search overlay panel.
     Wired here (not just in ebarza3d-additions.js) so the button works
     even if the assets bundle is stale or fails to load. A wired-flag on
     the trigger prevents double-binding when additions.js ALSO wires it. */
  (function () {
    var trigger = document.querySelector('.ebarza3d-search-trigger');
    var panel   = document.getElementById('ebarza3d-search');
    if (!trigger || !panel) return;
    if (trigger.dataset.searchWired === '1') return;
    trigger.dataset.searchWired = '1';

    var closeBtn = panel.querySelector('.ebarza3d-search__close');
    var input    = panel.querySelector('[data-ebarza-search-input]');
    var suggest  = document.querySelector('[data-suggest]');

    function openSearch() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      setTimeout(function () { if (input) { try { input.focus(); } catch (e) {} } }, 30);
    }
    function closeSearch() {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (suggest) suggest.hidden = true;
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (panel.hidden) openSearch(); else closeSearch();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeSearch();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) closeSearch();
    });

    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (panel.contains(e.target) || trigger.contains(e.target)) return;
      closeSearch();
    });
  })();

  /* Mobile burger menu toggle */
  (function () {
    var burger = document.querySelector('[data-mobile-burger]');
    var menu   = document.querySelector('[data-mobile-menu]');
    if (!burger || !menu) return;

    function setOpen(open) {
      menu.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.classList.toggle('mobile-menu-open', open);
    }

    burger.addEventListener('click', function () {
      setOpen(!menu.classList.contains('is-open'));
    });

    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) setOpen(false);
    });

    document.addEventListener('click', function (e) {
      if (!menu.classList.contains('is-open')) return;
      if (menu.contains(e.target) || burger.contains(e.target)) return;
      setOpen(false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebarza-3d-hero"]) return;
  try {
    
  /* ─── SUGAR PAUSE-WHEN-OFFSCREEN (ALL devices) ──────────────────
     Profiling on a 4x-throttled CPU showed the page scrolling at
     2 FPS with the viewer active vs 26 FPS with it hidden — Sugar's
     internal WebGL render loop keeps drawing even when the hero is
     scrolled out of view. `display:none` is the one reliable switch:
     model-viewer-based components fully halt rendering when hidden
     and resume WITHOUT reloading the model when shown again.
     rootMargin pre-warms 150px before re-entry so there's no pop-in. */
  (function () {
    window.__ebarzaHeroPerfV2 = true;  /* deployment marker */
    var hero    = document.getElementById('hero');
    var wrapper = document.getElementById('sugar-wrapper');
    if (!hero || !wrapper || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      hero.classList.toggle('is-offscreen', !visible);
      wrapper.style.display = visible ? '' : 'none';
      var mv = document.getElementById('hero-mv');
      if (mv && !mv.hasAttribute('hidden')) mv.style.display = visible ? '' : 'none';
    }, { threshold: 0, rootMargin: '150px 0px' });
    io.observe(hero);
  })();

  /* MOBILE: read the active tab's `data-sugar-orbit-mobile` +
     `data-sugar-target-mobile` (from the per-tab section settings)
     and apply them to the viewer. Also enables native auto-rotate +
     wider FOV. Runs BEFORE the desktop mouse-follow IIFE (which
     returns early on mobile). */
  (function () {
    if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) return;

    var MOBILE_FOV = '48deg';   /* wider FOV = model appears smaller */

    function applyMobile() {
      var sugar = document.getElementById('hero-sugar');
      var mv    = document.getElementById('hero-mv');
      var activeTab = document.querySelector('.info-tabs .tab.active') ||
                      document.querySelector('.info-tabs .tab[aria-selected="true"]') ||
                      document.querySelector('.info-tabs .tab');
      /* Pull mobile values from active tab; fallback to desktop attrs
         if mobile not set. Same logic as page-3d-library.js. */
      var orbit  = (activeTab && (activeTab.getAttribute('data-sugar-orbit-mobile')  || activeTab.getAttribute('data-sugar-orbit')))  || '50deg 60deg auto';
      var target = (activeTab && (activeTab.getAttribute('data-sugar-target-mobile') || activeTab.getAttribute('data-sugar-target'))) || '0m 0m 0m';

      [sugar, mv].forEach(function (el) {
        if (!el) return;
        el.setAttribute('camera-orbit', orbit);
        el.setAttribute('field-of-view', MOBILE_FOV);
        el.setAttribute('camera-target', target);
        el.setAttribute('auto-rotate', '');
        el.setAttribute('auto-rotate-delay', '1500');
        el.setAttribute('rotation-per-second', '18deg');
        try { el.autoRotate = true; } catch (e) {}
      });
    }

    setTimeout(applyMobile,  600);
    setTimeout(applyMobile, 1600);
    setTimeout(applyMobile, 3200);

    document.querySelectorAll('.info-tabs .tab').forEach(function (t) {
      t.addEventListener('click', function () {
        setTimeout(applyMobile,  300);
        setTimeout(applyMobile, 1400);
      });
    });
  })();

  /* DESKTOP: Hero 3D model follows the mouse — wide-range parallax via camera-orbit.
     Mouse X → H (theta, left/right) · Mouse Y → V (phi, up/down).
     Listens on `window` (NOT just the stage), so hovering buttons / header
     does NOT snap the model back. Only the cursor position relative to the
     stage center matters — model keeps tracking continuously.
     Front view (H=0, V=75) is the natural pose when the cursor sits at the
     stage center; it is no longer a forced "return" state.
     Applies orbit every animation frame, which also overrides any internal
     auto-rotation in sugar-model-viewer / model-viewer.
  */
  (function () {
    /* ──────────────────────────────────────────────────────────────
       MOUSE-FOLLOW KILL SWITCH — set to `true` to fully disable the
       cursor-tracking effect (used 2026-05-23 to confirm it was the
       scroll-lag culprit on weak machines). Now re-enabled WITH the
       full safety net below:
         · stops entirely when hero scrolls out of view (IO)
         · suspends during active scrolling (scroll always wins)
         · stops calling the viewer once the camera settles (EPSILON)
         · skipped on machines with ≤4 cores / ≤4GB RAM
         · rect cached, mousemove rAF-coalesced, tab-hidden pause
       ────────────────────────────────────────────────────────────── */
    var MOUSE_FOLLOW_DISABLED = false;
    if (MOUSE_FOLLOW_DISABLED) return;

    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    /* PERF: skip the continuous mouse-follow entirely on weak machines
       (≤4 CPU cores or ≤4GB RAM reported). Those devices showed 2 FPS
       scroll with the follow active. Users can still drag the model
       manually — only the automatic cursor tracking is disabled. */
    var cores = navigator.hardwareConcurrency || 8;
    var mem   = navigator.deviceMemory || 8;
    if (cores <= 4 || mem <= 4) return;

    var stage = document.getElementById('stage');
    if (!stage) return;

    var sugar = document.getElementById('hero-sugar');
    var mv    = document.getElementById('hero-mv');
    var hero  = document.getElementById('hero');

    var BASE_THETA = 320;   /* H */
    var BASE_PHI   = 40;    /* V */
    var THETA_RANGE = 120;  /* ±120° horizontal */
    var PHI_RANGE   = 55;   /* ±55° vertical */
    var NX_CLAMP    = 1.4;  /* cap cursor influence when far from stage */
    /* PERF: once the eased camera is within EPSILON degrees of its
       target we STOP calling setAttribute. The old code eased forever
       (0.18 lerp never reaches target mathematically), so it forced a
       WebGL re-render 60×/second permanently — pinning weak GPUs and
       making scrolling freeze on low-end machines. */
    var EPSILON = 0.05;

    var baseRadius = 'auto';
    var targetTheta  = BASE_THETA, targetPhi  = BASE_PHI;
    var currentTheta = BASE_THETA, currentPhi = BASE_PHI;
    var dragging = false, primed = false;

    /* PERF: pause ALL work when the hero is scrolled out of view or the
       tab is hidden. Scrolling the rest of the page costs zero. */
    var heroVisible = true;
    var rafId = null;

    /* PERF: cache the stage rect — the old code called
       getBoundingClientRect() on EVERY mousemove (forced layout ~100×/s).
       Now we recompute it lazily, only after a scroll/resize happened. */
    var stageRect = null, rectDirty = true;
    /* PERF: while the user is actively scrolling (and for 250ms after),
       the follow is suspended — no setAttribute, no WebGL re-render.
       Scroll smoothness always wins over the decorative effect. */
    var lastScrollTs = 0;
    var SCROLL_QUIET_MS = 250;
    function markRectDirty() { rectDirty = true; lastScrollTs = performance.now(); }
    window.addEventListener('resize', markRectDirty, { passive: true });
    window.addEventListener('scroll', markRectDirty, { passive: true });
    function getRect() {
      if (rectDirty) { stageRect = stage.getBoundingClientRect(); rectDirty = false; }
      return stageRect;
    }

    function killAutoRotate() {
      [sugar, mv].forEach(function (el) {
        if (!el) return;
        try { el.autoRotate = false; }   catch (e) {}
        try { el.auto_rotate = false; }  catch (e) {}
        try { if (typeof el.pause === 'function') el.pause(); } catch (e) {}
        el.removeAttribute('auto-rotate');
        el.removeAttribute('autorotate');
        el.removeAttribute('autoRotate');
        el.removeAttribute('auto-spin');
      });
    }

    function readBaseRadius() {
      var elem = (sugar && !sugar.hidden) ? sugar : mv;
      if (!elem) return;
      var raw = elem.getAttribute('camera-orbit');
      if (raw) {
        var parts = raw.trim().split(/\s+/);
        baseRadius = parts[2] || 'auto';
      }
      primed = true;
      killAutoRotate();
    }

    setTimeout(readBaseRadius, 900);
    setTimeout(killAutoRotate, 1500);
    setTimeout(killAutoRotate, 3000);

    document.querySelectorAll('.info-tabs .tab').forEach(function (t) {
      t.addEventListener('click', function () {
        setTimeout(readBaseRadius, 350);
        setTimeout(killAutoRotate, 800);
        setTimeout(killAutoRotate, 1800);
      });
    });

    stage.addEventListener('pointerdown', function () { dragging = true; });
    window.addEventListener('pointerup',   function () { dragging = false; });
    window.addEventListener('pointercancel', function () { dragging = false; });

    function applyOrbit(theta, phi) {
      var orbit = theta.toFixed(2) + 'deg ' + phi.toFixed(2) + 'deg ' + baseRadius;
      if (sugar) sugar.setAttribute('camera-orbit', orbit);
      if (mv && !mv.hasAttribute('hidden')) mv.setAttribute('camera-orbit', orbit);
    }

    function updateTargetFromMouse(clientX, clientY) {
      if (!primed || dragging) return;
      var rect = getRect();
      if (!rect || !rect.width) return;
      var hw = rect.width  / 2;
      var hh = rect.height / 2;
      var nx = (clientX - (rect.left + hw)) / hw;     /* -1 at left edge, +1 at right */
      var ny = (clientY - (rect.top  + hh)) / hh;
      if (nx >  NX_CLAMP) nx =  NX_CLAMP;
      if (nx < -NX_CLAMP) nx = -NX_CLAMP;
      if (ny >  NX_CLAMP) ny =  NX_CLAMP;
      if (ny < -NX_CLAMP) ny = -NX_CLAMP;
      targetTheta = BASE_THETA + nx * THETA_RANGE;    /* X → H */
      targetPhi   = BASE_PHI   - ny * PHI_RANGE;      /* Y → V */
      if (targetPhi < 20)  targetPhi = 20;
      if (targetPhi > 150) targetPhi = 150;
    }

    /* PERF: mousemove is rAF-coalesced — we only stash the latest event
       and process it once per frame inside tick(). Early-exit when the
       hero isn't visible so moving the mouse elsewhere costs nothing. */
    var pendingX = null, pendingY = null;
    window.addEventListener('mousemove', function (e) {
      if (!heroVisible) return;
      pendingX = e.clientX;
      pendingY = e.clientY;
    }, { passive: true });

    function tick() {
      rafId = requestAnimationFrame(tick);
      if (!primed || dragging) return;
      /* Scroll in progress (or just ended)? Stand down completely. */
      if (performance.now() - lastScrollTs < SCROLL_QUIET_MS) return;
      if (pendingX !== null) {
        updateTargetFromMouse(pendingX, pendingY);
        pendingX = null;
      }
      var dT = targetTheta - currentTheta;
      var dP = targetPhi   - currentPhi;
      /* Settled? Snap and STOP touching the viewer — lets the WebGL
         canvas go idle so the browser stops re-rendering it. */
      if (Math.abs(dT) < EPSILON && Math.abs(dP) < EPSILON) return;
      currentTheta += dT * 0.18;
      currentPhi   += dP * 0.18;
      applyOrbit(currentTheta, currentPhi);
    }
    function startLoop() {
      if (rafId === null) rafId = requestAnimationFrame(tick);
    }
    function stopLoop() {
      if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; }
    }

    /* Pause the whole system when the hero scrolls out of view.
       Also toggles `is-offscreen` on #hero so CSS can pause the
       infinite measure-ring animation (box-shadow repaints). */
    if ('IntersectionObserver' in window && hero) {
      var io = new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        hero.classList.toggle('is-offscreen', !heroVisible);
        if (heroVisible && !document.hidden) startLoop();
        else stopLoop();
      }, { threshold: 0 });
      io.observe(hero);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopLoop();
      else if (heroVisible) startLoop();
    });

    startLoop();
  })();

  /* ─── 3D POSITION HELPER WIDGET ─────────────────────────────────
     Listens to the Sugar viewer's camera state. Updates the panel
     with live orbit + target values. Copy buttons write the values
     to clipboard formatted for the theme editor settings field. */
  (function () {
    var panel = document.getElementById('hero-poshelper');
    if (!panel) return; // helper disabled by setting

    var orbitEl  = document.getElementById('hero-poshelper-orbit');
    var targetEl = document.getElementById('hero-poshelper-target');
    var feedback = document.getElementById('hero-poshelper-feedback');
    var sugar    = document.getElementById('hero-sugar');
    if (!sugar) return;

    var lastOrbit  = '';
    var lastTarget = '';

    function readState() {
      try {
        var orbit  = sugar.getAttribute('camera-orbit')  ||
                     (sugar.cameraOrbit  && (sugar.cameraOrbit.toString  ? sugar.cameraOrbit.toString()  : String(sugar.cameraOrbit)));
        var target = sugar.getAttribute('camera-target') ||
                     (sugar.cameraTarget && (sugar.cameraTarget.toString ? sugar.cameraTarget.toString() : String(sugar.cameraTarget)));
        if (orbit && orbit !== lastOrbit) {
          lastOrbit = orbit;
          orbitEl.textContent = orbit;
        }
        if (target && target !== lastTarget) {
          lastTarget = target;
          targetEl.textContent = target;
        }
      } catch (e) { /* viewer not ready */ }
    }

    /* Poll @ 250ms — `camera-change` events are unreliable across
       sugar-viewer / model-viewer / shadow DOM. Cheap, only runs when
       helper is enabled (which should be off in production). */
    var pollId = setInterval(readState, 250);
    readState();

    /* Copy buttons */
    panel.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-poshelper-copy]');
      if (!btn) return;
      var which = btn.getAttribute('data-poshelper-copy'); // 'desktop' | 'mobile'
      var payload = 'orbit: ' + lastOrbit + '\ntarget: ' + lastTarget;
      navigator.clipboard.writeText(payload).then(function () {
        feedback.textContent = 'Copied (' + which + ') — paste into the matching settings field';
        setTimeout(function () { feedback.textContent = ''; }, 3000);
      }).catch(function () {
        feedback.textContent = 'Copy failed — values shown above, copy manually';
        setTimeout(function () { feedback.textContent = ''; }, 4000);
      });
    });

    /* Stop polling if user closes the page */
    window.addEventListener('beforeunload', function () { clearInterval(pollId); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebarza-3d-register"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('#register.ebarza3d-reg');
    if (!root) return;
    var tabs = root.querySelectorAll('[data-reg-tab]');
    var panels = root.querySelectorAll('[data-reg-panel]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var target = t.getAttribute('data-reg-tab');
        tabs.forEach(function (x) {
          var active = x === t;
          x.classList.toggle('is-active', active);
          x.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var match = p.getAttribute('data-reg-panel') === target;
          p.classList.toggle('is-active', match);
          if (match) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
        });
      });
    });

    // Inject Liquid Glass styles INTO the Shopify Forms open shadow root.
    // Shopify Forms renders its form inside <shopify-forms-embed>#shadow-root (open),
    // so external CSS can't reach the inputs/buttons/file zones — but JS can append
    // a <style> tag inside the shadow root, where it becomes first-class CSS.
    var SHADOW_CSS =
      /* HOST OVERRIDES — set the master vars from inside the shadow root */
      ":host, :host([data-form-root]) {" +
        "--col-size: 100% !important;" +
        "--container-min-height: auto !important;" +
        "--form-field-padding: 14px !important;" +
        "--form-field-padding-top: 22px !important;" +
        "--form-field-padding-bottom: 10px !important;" +
        "--forms-base-font-line-height: 1.5 !important;" +
        "--input-border-radius: 12px !important;" +
        "--button-border-radius: 999px !important;" +
        "--container-border-radius: 16px !important;" +
        "--forms-focus-outline-color: #1c1c1c !important;" +
        "--forms-focus-outline-width: 3px !important;" +
        "--forms-focus-outline-offset: 0 !important;" +
        "--subdued-text-color: rgba(140,120,109,0.85) !important;" +
        "--close-button-size: 14px !important;" +
        "width: 100% !important;" +
        "max-width: 100% !important;" +
      "}" +

      /* Force ALL inner form containers to fill width */
      "form, section, [class*='formContainer' i], [class*='form-container' i]," +
      "[class*='gridItem' i], [class*='grid-item' i], [class*='formField' i]," +
      "[class*='formFieldset' i], [class*='formFieldContainer' i]," +
      "[class*='inputContainer' i], [class*='input-container' i]," +
      "[class*='inline' i] {" +
        "width: 100% !important;" +
        "max-width: 100% !important;" +
        "min-width: 0 !important;" +
        "grid-template-columns: 1fr !important;" +
      "}" +
      "form > div, form > section, [data-form-root] > div, [data-form-root] > section {" +
        "width: 100% !important;" +
        "max-width: 100% !important;" +
      "}" +

      /* Phone field — flag + tel inline, natural heights (no stretch bloat) */
      "[class*='phone' i], [class*='tel' i]:not(input)," +
      ":is([class*='phoneField' i], [class*='phone-field' i], [class*='telField' i]) {" +
        "display: flex !important;" +
        "flex-direction: row !important;" +
        "flex-wrap: nowrap !important;" +
        "align-items: center !important;" +
        "gap: 8px !important;" +
        "width: 100% !important;" +
        "height: auto !important;" +
        "min-height: 0 !important;" +
      "}" +
      "[class*='phone' i] input[type='tel'], [class*='tel' i] input, input[type='tel'] {" +
        "flex: 1 1 auto !important;" +
        "min-width: 0 !important;" +
        "height: auto !important;" +
      "}" +
      /* The CLOSED dial-code chip only (button that opens the dropdown).
         Carefully exclude listbox/options so the open menu isn't squashed. */
      "[class*='phone' i] > button:not([class*='option' i]):not([class*='list' i]):not([role='option'])," +
      "[class*='phone' i] > [role='combobox']," +
      "[class*='dial' i]:not([role='listbox']):not([role='option']):not([role='menu']):not([class*='option' i]):not([class*='dropdown' i]):not([class*='menu' i]):not([class*='list' i]):not([class*='popover' i]):not(li)," +
      "[class*='country-code' i]:not([role='listbox']):not([role='option']):not([class*='option' i]):not(li)," +
      "[class*='flag-button' i] {" +
        "flex: 0 0 auto !important;" +
        "width: auto !important;" +
        "min-width: 76px !important;" +
        "max-width: 100px !important;" +
        "padding: 0 10px !important;" +
        "height: 52px !important;" +
        "min-height: 0 !important;" +
        "max-height: 52px !important;" +
      "}" +

      /* Country dropdown menu (when OPEN) — full width, never constrained */
      "[role='listbox'], [role='menu'], [class*='listbox' i]," +
      "[class*='dropdown-menu' i], [class*='dropdownMenu' i]," +
      "[class*='options-list' i], [class*='optionsList' i]," +
      "[class*='countryList' i], [class*='country-list' i]," +
      "[class*='popover' i]:not(button), [class*='popup' i]:not(button) {" +
        "width: auto !important;" +
        "max-width: none !important;" +
        "min-width: 240px !important;" +
        "max-height: 300px !important;" +
        "overflow-y: auto !important;" +
        "padding: 6px !important;" +
      "}" +
      "[role='option'], [class*='option' i]:not(button):not([class*='options' i])," +
      "[role='listbox'] li, [role='menu'] li {" +
        "width: 100% !important;" +
        "max-width: none !important;" +
        "min-width: 0 !important;" +
        "white-space: nowrap !important;" +
        "padding: 8px 12px !important;" +
        "min-height: 0 !important;" +
        "height: auto !important;" +
        "font-size: 13px !important;" +
        "border-radius: 6px !important;" +
      "}" +
      "[role='option']:hover, [role='option'][aria-selected='true'] {" +
        "background: rgba(28,28,28,0.06) !important;" +
      "}" +
      "* { box-sizing: border-box; }" +
      "input, textarea, select {" +
        "border-radius: 12px !important;" +
        "border: 1px solid rgba(140,120,109,0.25) !important;" +
        "background: rgba(255,255,255,0.92) !important;" +
        "padding: 22px 16px 10px !important;" +
        "font-family: 'Inter', 'Archivo', system-ui, sans-serif !important;" +
        "font-size: 14px !important;" +
        "font-weight: 500 !important;" +
        "color: #1c1c1c !important;" +
        "min-height: 52px !important;" +
        "box-sizing: border-box !important;" +
        "box-shadow: inset 0 1px 0 0 rgba(255,255,255,0.55) !important;" +
        "transition: border-color 200ms, box-shadow 200ms, background 200ms !important;" +
        "outline: none !important;" +
      "}" +
      "input:focus, textarea:focus, select:focus {" +
        "border-color: #1c1c1c !important;" +
        "background: #fff !important;" +
        "box-shadow: 0 0 0 4px rgba(28,28,28,0.06), inset 0 1px 0 0 rgba(255,255,255,0.55) !important;" +
      "}" +
      "input::placeholder, textarea::placeholder { color: rgba(140,120,109,0.7) !important; font-weight: 400 !important; }" +
      "textarea { resize: vertical !important; min-height: 96px !important; line-height: 1.5 !important; }" +
      "label, [class*='label' i]:not(input):not(textarea):not(button) {" +
        "font-family: 'Archivo', sans-serif !important;" +
        "font-weight: 700 !important;" +
        "font-size: 11.5px !important;" +
        "letter-spacing: 0.14em !important;" +
        "text-transform: uppercase !important;" +
        "color: rgba(28,28,28,0.78) !important;" +
        "margin-bottom: 6px !important;" +
        "line-height: 1.4 !important;" +
        "display: block !important;" +
      "}" +
      "p { color: rgba(28,28,28,0.72) !important; font-size: 13.5px !important; line-height: 1.55 !important; }" +

      /* File upload zone — minimal dashed card, NOT pill-shaped. Targeted to outer container only. */
      "[class*='dropzone' i], [data-file-upload], [class*='fileZone' i], [class*='file-zone' i], [class*='formField' i] [class*='file' i]:not(button):not(input):not([role='button']):not([class*='button' i]) {" +
        "border: 1.5px dashed rgba(140,120,109,0.35) !important;" +
        "border-radius: 12px !important;" +
        "background: rgba(255,255,255,0.55) !important;" +
        "padding: 12px 14px !important;" +
        "min-height: auto !important;" +
        "transition: border-color 220ms, background 220ms !important;" +
        "cursor: pointer !important;" +
      "}" +
      "[class*='dropzone' i]:hover, [data-file-upload]:hover {" +
        "border-color: rgba(28,28,28,0.4) !important;" +
        "background: rgba(255,255,255,0.8) !important;" +
      "}" +
      "input[type='file'] {" +
        "border: 1.5px dashed rgba(140,120,109,0.35) !important;" +
        "border-radius: 12px !important;" +
        "background: rgba(255,255,255,0.55) !important;" +
        "padding: 12px !important;" +
        "cursor: pointer !important;" +
        "font-size: 13px !important;" +
      "}" +

      /* Secondary buttons (Add file, Remove, etc.) — tiny rectangular chip */
      "button:not([type='submit']):not([type='reset']), [role='button']:not([type='submit']):not([class*='dropzone' i]):not([class*='file-zone' i]) {" +
        "background: transparent !important;" +
        "color: #8c786d !important;" +
        "border: 1px solid rgba(140,120,109,0.32) !important;" +
        "border-radius: 4px !important;" +
        "padding: 1px 7px !important;" +
        "font-family: 'Archivo', sans-serif !important;" +
        "font-weight: 600 !important;" +
        "font-size: 8.5px !important;" +
        "letter-spacing: 0.1em !important;" +
        "text-transform: uppercase !important;" +
        "min-height: 18px !important;" +
        "height: 18px !important;" +
        "line-height: 1 !important;" +
        "width: auto !important;" +
        "max-width: max-content !important;" +
        "cursor: pointer !important;" +
        "box-shadow: none !important;" +
        "transition: background 180ms, color 180ms, border-color 180ms !important;" +
        "display: inline-flex !important;" +
        "align-items: center !important;" +
        "justify-content: center !important;" +
        "gap: 3px !important;" +
      "}" +
      "button:not([type='submit']):not([type='reset']):hover {" +
        "background: rgba(28,28,28,0.06) !important;" +
        "color: #1c1c1c !important;" +
        "border-color: rgba(28,28,28,0.4) !important;" +
      "}" +

      /* Submit button — balanced rectangle, contained within form padding */
      "button[type='submit'], input[type='submit'] {" +
        "background: #1c1c1c !important;" +
        "color: #f4f4ec !important;" +
        "border: 0 !important;" +
        "border-radius: 10px !important;" +
        "padding: 14px 28px !important;" +
        "margin: 0 !important;" +
        "font-family: 'Archivo', sans-serif !important;" +
        "font-weight: 700 !important;" +
        "font-size: 11px !important;" +
        "letter-spacing: 0.22em !important;" +
        "text-transform: uppercase !important;" +
        "cursor: pointer !important;" +
        "min-height: 50px !important;" +
        "height: 50px !important;" +
        "width: 100% !important;" +
        "max-width: 100% !important;" +
        "min-width: 0 !important;" +
        "box-sizing: border-box !important;" +
        "box-shadow: 0 6px 18px -4px rgba(28,28,28,0.35) !important;" +
        "transition: background 200ms, transform 200ms, box-shadow 200ms !important;" +
        "display: flex !important;" +
        "align-items: center !important;" +
        "justify-content: center !important;" +
        "gap: 8px !important;" +
      "}" +
      "button[type='submit']:hover {" +
        "background: #3a3a3a !important;" +
        "transform: translateY(-1px) !important;" +
        "box-shadow: 0 10px 24px -4px rgba(28,28,28,0.45) !important;" +
      "}" +
      "button[type='submit']:active { transform: translateY(0) !important; }" +
      /* Submit's parent container — keep it contained */
      "[class*='formActions' i], [class*='submit' i]:not(button):not(input) {" +
        "width: 100% !important;" +
        "max-width: 100% !important;" +
        "padding: 0 !important;" +
        "margin: 0 !important;" +
        "box-sizing: border-box !important;" +
        "display: block !important;" +
      "}" +

      /* Field spacing */
      "form > * + *, [class*='formField' i] + [class*='formField' i] { margin-top: 14px !important; }" +
      /* Errors / success */
      "[class*='error' i]:not(input):not(textarea), [role='alert'] { color: #cb2b2b !important; font-size: 12.5px !important; }" +
      "[class*='success' i]:not(input):not(textarea), [data-success-message] {" +
        "padding: 16px 18px !important;" +
        "background: rgba(48,122,7,0.1) !important;" +
        "border: 1px solid rgba(48,122,7,0.3) !important;" +
        "border-radius: 12px !important;" +
        "color: #1c5704 !important;" +
      "}";

    function styleShopifyFormShadow() {
      var embeds = document.querySelectorAll('shopify-forms-embed, [is*="form"]');
      embeds.forEach(function (embed) {
        if (!embed.shadowRoot) return;
        if (embed.shadowRoot.querySelector('style[data-ebarza-injected]')) return;
        var styleEl = document.createElement('style');
        styleEl.setAttribute('data-ebarza-injected', 'true');
        styleEl.textContent = SHADOW_CSS;
        embed.shadowRoot.appendChild(styleEl);
      });
    }

    /* Initial pass + re-run on DOM changes (Shopify Forms renders async) */
    styleShopifyFormShadow();
    var formObserver = new MutationObserver(function () { styleShopifyFormShadow(); });
    formObserver.observe(document.body, { childList: true, subtree: true });

    /* Stop after 30s — form is definitely loaded by then */
    setTimeout(function () { formObserver.disconnect(); }, 30000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebarza-3d-search"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-ebarza-libsearch]');
    if (!root) return;
    var input = root.querySelector('[data-ebarza-search-input]');
    var dropdown = root.querySelector('[data-ebarza-libsuggest]');
    var results = root.querySelector('[data-ebarza-libsuggest-results]');
    if (!input || !dropdown || !results) return;

    var timer = null;
    var lastQ = '';

    function show() {
      dropdown.removeAttribute('hidden');
      input.setAttribute('aria-expanded', 'true');
    }
    function hide() {
      dropdown.setAttribute('hidden', '');
      input.setAttribute('aria-expanded', 'false');
    }

    function fmtPrice(cents) {
      if (cents == null || isNaN(cents)) return '';
      try {
        return new Intl.NumberFormat('en-AE', { style: 'currency', currency: 'AED', maximumFractionDigits: 0 }).format(cents / 100);
      } catch (e) {
        return 'AED ' + Math.round(cents / 100);
      }
    }

    function escapeHtml(s) {
      return String(s || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function render(products, query) {
      if (!products.length) {
        results.innerHTML =
          '<div class="ebarza3d-libsuggest__empty">' +
            '<p class="eyebrow text-taupe">— No 3D models found</p>' +
            '<p>Try a broader keyword like &ldquo;sofa&rdquo; or &ldquo;dining&rdquo;.</p>' +
          '</div>';
        return;
      }

      var cards = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        var price = fmtPrice(p.price);
        return (
          '<a class="ebarza3d-libsuggest__item" href="' + escapeHtml(p.url) + '">' +
            '<div class="ebarza3d-libsuggest__thumb">' +
              (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') +
            '</div>' +
            '<div class="ebarza3d-libsuggest__meta">' +
              '<span class="ebarza3d-libsuggest__badge">3D · .glb · .usdz</span>' +
              '<h4 class="ebarza3d-libsuggest__title">' + escapeHtml(p.title) + '</h4>' +
              (price ? '<span class="ebarza3d-libsuggest__price">' + price + '</span>' : '') +
            '</div>' +
          '</a>'
        );
      }).join('');

      var viewall =
        '<a class="ebarza3d-libsuggest__viewall" href="/search?q=' +
        encodeURIComponent(query + ' tag:3D-MODEL') +
        '&type=product">View all 3D results →</a>';

      results.innerHTML = cards + viewall;
    }

    function fetchSuggest(query) {
      var q = (query + ' tag:3D-MODEL').trim();
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product' +
        '&resources[options][unavailable_products]=last' +
        '&resources[limit]=9';
      return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          return (data && data.resources && data.resources.results && data.resources.results.products) || [];
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { hide(); lastQ = ''; return; }
      if (q === lastQ) return;
      lastQ = q;
      timer = setTimeout(function () {
        fetchSuggest(q).then(function (products) {
          render(products, q);
          show();
        }).catch(function () { hide(); });
      }, 180);
    });

    input.addEventListener('focus', function () {
      var q = input.value.trim();
      if (q.length >= 2) {
        fetchSuggest(q).then(function (products) {
          render(products, q);
          show();
        }).catch(function () {});
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) hide();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hide(); input.blur(); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebarza-3d-workflow"]) return;
  try {
    
  (function () {
    var root = document.querySelector('#workflow.ebarza3d-flow');
    if (!root) return;

    /* Respect prefers-reduced-motion — show immediately */
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    if (rm && rm.matches) {
      root.classList.add('is-visible');
      return;
    }

    if (!('IntersectionObserver' in window)) {
      root.classList.add('is-visible');
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          root.classList.add('is-visible');
          obs.disconnect();
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -60px 0px' });

    obs.observe(root);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebarza-clearance-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var grid = document.querySelector('[data-clr-grid]');
    var moreBtn = document.querySelector('[data-clr-more]');
    var loading = document.querySelector('[data-clr-loading]');
    var sentinel = document.querySelector('[data-clr-sentinel]');
    if (!grid) return;

    var DISC = parseFloat(grid.getAttribute('data-discount')) || 0;   /* % off */
    var BATCH = 48, shown = 0, data = [];

    function money(v) {
      if (v == null || v === '') return '';
      var n = parseFloat(v); if (isNaN(n)) return '';
      return 'AED ' + Math.round(n).toLocaleString('en-AE');
    }
    function esc(s) { return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

    function cardHTML(p) {
      var soldOut = (p.qty != null) && (p.qty <= 0);
      var tag = (p.url && !soldOut) ? 'a' : 'div';
      var href = (p.url && !soldOut) ? ' href="' + esc(p.url) + '"' : '';

      var orig = parseFloat(p.price);
      var priceHtml = '';
      if (!isNaN(orig) && orig > 0) {
        if (DISC > 0) {
          var sale = Math.round(orig * (100 - DISC) / 100);
          priceHtml = '<span class="clr-card__price">' + money(sale) + '</span>' +
                      '<span class="clr-card__was">' + money(orig) + '</span>';
        } else {
          priceHtml = '<span class="clr-card__price">' + money(orig) + '</span>';
        }
      }

      var qtyHtml = '';
      if (!soldOut && p.qty != null) {
        qtyHtml = '<span class="clr-card__qty">' + p.qty + ' in showroom</span>';
      }

      return '<' + tag + ' class="clr-card' + (soldOut ? ' clr-card--sold' : '') + '"' + href + '>' +
        '<span class="clr-card__imgwrap">' +
          (p.image ? '<img class="clr-card__img" src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          (DISC > 0 && !soldOut ? '<span class="clr-card__badge">-' + DISC + '%</span>' : '') +
          (soldOut ? '<span class="clr-card__sold"><span>Display Sold-Out</span></span>' : '') +
        '</span>' +
        '<span class="clr-card__t">' + esc(p.title) + '</span>' +
        '<span class="clr-prod-price-row">' + priceHtml + '</span>' +
        qtyHtml +
      '</' + tag + '>';
    }

    function renderNext() {
      var slice = data.slice(shown, shown + BATCH);
      grid.insertAdjacentHTML('beforeend', slice.map(cardHTML).join(''));
      shown += slice.length;
      if (moreBtn) moreBtn.hidden = shown >= data.length;
    }

    function start() {
      /* Data file is already in the collection's sort order — render as-is. */
      data = (window.YAS_CLEARANCE || []).slice();
      if (loading) loading.remove();
      if (!data.length) { grid.innerHTML = '<div class="clr-prod__loading">No Yas showroom stock found. Regenerate the data file.</div>'; return; }
      renderNext();

      /* INFINITE SCROLL — auto-load the next batch when the sentinel
         nears the viewport. Button stays as fallback for old browsers. */
      if ('IntersectionObserver' in window && sentinel) {
        if (moreBtn) moreBtn.style.display = 'none';
        var io = new IntersectionObserver(function (entries) {
          if (!entries[0].isIntersecting) return;
          if (shown >= data.length) { io.disconnect(); return; }
          renderNext();
        }, { rootMargin: '900px 0px' });
        io.observe(sentinel);
      }
    }

    if (moreBtn) moreBtn.addEventListener('click', renderNext);
    if (window.YAS_CLEARANCE) start();
    else {
      var tries = 0, iv = setInterval(function () { tries++; if (window.YAS_CLEARANCE) { clearInterval(iv); start(); } else if (tries > 100) { clearInterval(iv); start(); } }, 100);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ebarza-clearance-search"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form   = document.querySelector('[data-clr-search]');
    if (!form) return;
    var input  = form.querySelector('[data-clr-search-input]');
    var suggest = document.querySelector('[data-clr-suggest]');
    var results = document.querySelector('[data-clr-suggest-results]');
    var viewall = document.querySelector('[data-clr-suggest-viewall]');

    /* Yas tags the clearance is scoped to. */
    var YAS_TAGS = ['yas-stock', 'yas-display'];

    function scopedSearchUrl(q) {
      var query = (q || '').trim();
      /* Inline search operators: term AND (tag:Yas-STOCK OR tag:Yas-DISPLAY) */
      var full = query
        ? query + ' AND (tag:Yas-STOCK OR tag:Yas-DISPLAY)'
        : 'tag:Yas-STOCK OR tag:Yas-DISPLAY';
      return '/search?q=' + encodeURIComponent(full) +
             '&type=product&options%5Bunavailable_products%5D=hide';
    }

    /* On submit, rewrite q to the scoped operator string. */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      window.location.href = scopedSearchUrl(input.value);
    });

    function escHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
        .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }

    function hasYasTag(p) {
      var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
      return YAS_TAGS.some(function (yt) { return tags.indexOf(yt) !== -1; });
    }

    var timer = null, reqId = 0;
    function fetchSuggest(q) {
      var mine = ++reqId;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
                '&resources[type]=product&resources[limit]=10' +
                '&resources[options][unavailable_products]=hide' +
                '&resources[options][fields]=title,product_type,vendor,tag';
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        if (mine !== reqId) return;
        var items = ((data.resources || {}).results || {}).products || [];
        var yas = items.filter(hasYasTag).slice(0, 6);
        render(yas, q);
      }).catch(function () {});
    }

    function render(products, q) {
      if (!results) return;
      if (!products.length) {
        results.innerHTML = '<div class="clr-suggest__empty">No Yas clearance matches for “' + escHtml(q) + '”. Try a broader term.</div>';
      } else {
        results.innerHTML = products.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          return '<a href="' + escHtml(p.url) + '" class="clr-suggest__item">' +
            '<span class="clr-suggest__thumb">' + (img ? '<img src="' + escHtml(img) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span><span class="clr-suggest__title">' + escHtml(p.title) + '</span>' +
            '<span class="clr-suggest__badge">● Yas Showroom</span></span></a>';
        }).join('');
      }
      if (viewall) viewall.href = scopedSearchUrl(q);
      if (suggest) suggest.hidden = false;
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { if (suggest) suggest.hidden = true; return; }
      timer = setTimeout(function () { fetchSuggest(q); }, 200);
    });

    document.addEventListener('click', function (e) {
      if (!suggest || suggest.hidden) return;
      if (form.contains(e.target) || suggest.contains(e.target)) return;
      suggest.hidden = true;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
